import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Button, Spinner } from 'react-bootstrap';

const OrderWorkflowActionButton = ({ pending, pendingLabel = '处理中…', icon, disabled, onClick, children }) => {
	const clickLockRef = useRef(false);

	useEffect(() => {
		if (!pending && !disabled) {
			clickLockRef.current = false;
		}
	}, [pending, disabled]);

	if (pending) {
		return (
			<div className='text-end' aria-busy='true' aria-live='polite'>
				<span className='d-inline-flex align-items-center gap-1 fs-11 text-warning'>
					<Spinner animation='border' size='sm' role='status' />
					{pendingLabel}
				</span>
			</div>
		);
	}

	return (
		<Button
			size='sm'
			className='fs-11'
			variant='outline-warning'
			disabled={disabled}
			onClick={(event) => {
				if (disabled || clickLockRef.current) return;
				clickLockRef.current = true;
				if (onClick?.(event) === false) {
					clickLockRef.current = false;
				}
			}}
		>
			{icon ? <FontAwesomeIcon icon={icon} className='me-1' /> : null}
			{children}
		</Button>
	);
};

OrderWorkflowActionButton.propTypes = {
	pending: PropTypes.bool,
	pendingLabel: PropTypes.string,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.node,
};

export default OrderWorkflowActionButton;
